/**
 * QuickBooks Online — post-OAuth success landing page.
 *
 * NOT one of the two Intuit-registered URLs (/qbo/connect,
 * /qbo/disconnected) — this is where ClickPay's OWN backend callback
 * (backend/ops/routes/qbo.py, `_FRONTEND_CONNECTED_PATH`) sends the browser
 * after a successful token exchange. Added alongside the two registered
 * pages because without it, a completed connect flow lands on an unmatched
 * route (AppRoutes.tsx has no catch-all). See the QboConnect docblock for
 * the registered pages.
 *
 * Rendered OUTSIDE the ClickPay auth wall / app shell (see App.tsx), same
 * reasoning as the other /qbo/* pages.
 */
import { CheckCircle2 } from 'lucide-react'
import { settingsHref } from './settings/routing'

export default function QboConnected() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto w-12 h-12 rounded-xl bg-brand-600 text-white flex items-center justify-center mb-3 shadow-sm">
          <CheckCircle2 size={22} aria-hidden />
        </div>
        <h1 className="text-xl font-semibold text-gray-900">ClickPay</h1>
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 mt-4">
          <p className="text-sm text-gray-900">
            QuickBooks is connected.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            ClickPay can now read bills, bill payments, and purchases from
            your QuickBooks Online account to reconcile supplier payments.
          </p>
          <a
            href={settingsHref('integrations')}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1 mt-4"
          >
            Back to Integrations
          </a>
        </div>
      </div>
    </div>
  )
}
